'use client';

import { useContext } from 'react';
import GlobalContext from '../../../context/global-context';
import { dispatch } from '../../../hooks/use-bus';
import useIsIframe from '../../../hooks/use-is-iframe';
import { useOverwolfApi } from '../../../hooks/use-overwolf-api';
import { AppBusEventType } from '../../../interfaces/bus-events';
import SpriteIcon from '../../shared/sprite-icon';
import { HeaderGuestMenu } from './header-guest-menu';
import UserSettingsMenu from './user-settings-menu/user-settings-menu';

// -----------------------------------------------------------------------------
export const HeaderLoginButton = (props): JSX.Element => {
  const { isCheckingLogin, isLoggedIn } = props;
  const isIframe = useIsIframe();
  const { isAvailable: isOverwolf } = useOverwolfApi();
  const { config } = useContext(GlobalContext);

  // When embedded in an iframe we normally hide the login / profile UI, but
  // inside the Overwolf client the user can sign in, so keep it visible there.
  if (isIframe && !isOverwolf) {
    return <></>;
  }

  // The account icon + hover dropdown (Login / My Account) is the entry point.
  // Inside the Overwolf app it's always used; on the public web it's gated by
  // WEBSITE_SHOW_LOGIN_DROP_DOWN, which otherwise falls back to the classic
  // "Login" text button.
  const inOverwolfIframe = isIframe && isOverwolf;
  const showLoginDropdown =
    inOverwolfIframe ||
    (config?.publicRuntimeConfig?.adminParams?.WEBSITE_SHOW_LOGIN_DROP_DOWN ??
      false);

  return (
    <>
      {isCheckingLogin && (
        <div className="rotating-loader">
          <SpriteIcon icon="loader" />
        </div>
      )}

      {!isCheckingLogin && (
        <>
          {/* Logged out: the account dropdown, or the classic Login button
              when the dropdown is disabled on the web. Logged in: the profile
              circle. */}
          {!isLoggedIn &&
            (showLoginDropdown ? (
              <HeaderGuestMenu />
            ) : (
              <button
                onClick={() => {
                  dispatch({
                    type: AppBusEventType.App.ShowLoginModal,
                    data: { show: true, source: 'header' },
                  });
                }}
                className="clean-btn login-btn"
              >
                Login
              </button>
            ))}
          {isLoggedIn && <UserSettingsMenu />}
        </>
      )}
    </>
  );
};
